import React, { useState, useEffect, useContext } from 'react'
import { useHistory } from 'react-router-dom'
import moment from 'moment'
import ReactGA from 'react-ga'
import RECURRENCE from '@cobasi/cobasi-utils/constants/recurrence'
import Swal from 'sweetalert2'
import DatePicker, { registerLocale } from 'react-datepicker'
import ptBR from 'date-fns/locale/pt-BR'
import Alert from '../components/Form/Alert'
import { sendSolicitation } from '../../../services/solicitations'
import { getAllFreelancersByProfessionalId } from '../../../services/professionals'
import { FaChevronLeft } from 'react-icons/fa'
import { CustomButton } from '../../../styles/global'
import { Input, Checkbox, Select } from '../../../components/Form'
import { SOLICITATION_CATEGORY, getRecurrenceOptions } from '../../../utils/constants'
import { RootContext } from '../../../context/rootContext'
import {
  Title,
  Row
} from './styles'
import SideMenuTemplate from '../templates/SideMenu'

registerLocale('ptBR', ptBR)

const AgendaBlockSolicitationView = () => {
  const [professionalData, setProfessionalData] = useState()
  const [startDate, setStartDate] = useState(moment(new Date()).format('YYYY-MM-DD'))
  const [endDate, setEndDate] = useState(moment(new Date()).add(1, 'day').format('YYYY-MM-DD'))
  const [startTime, setStartTime] = useState('00:00')
  const [endTime, setEndTime] = useState('00:00')
  const [selectedRecurrence, setSelectedRecurrence] = useState('')
  const [allDayChecked, setAllDayChecked] = useState(false)
  const [errors, setErrors] = useState({
    startDate: undefined,
    endDate: undefined,
    startTime: undefined,
    endTime: undefined,
    selectedRecurrence: undefined,
    selectedSubstitute: undefined,
    others: undefined
  })
  const [loading, setLoading] = useState(false)
  const [substituteList, setSubstituteList] = useState([])
  const [selectedSubstitute, setSelectedSubstitute] = useState('')
  const { handleUpdateSolicitation } = useContext(RootContext)

  const history = useHistory()

  const handleBackPage = () => {
    history.push('/vets/solicitations')
    ReactGA.pageview('/vets/solicitations')
  }

  useEffect(() => {
    const { professional } = JSON.parse(localStorage.getItem('userData'))
    setProfessionalData(professional)
  }, [])

  useEffect(() => {
    const allDay = (startTime === '00:00' && endTime === '00:00')
    setAllDayChecked(allDay)
    handleStartDate(startDate)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startTime, endTime])

  useEffect(() => {
    handleStartDate(startDate)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedRecurrence])

  useEffect(() => {
    if (professionalData && professionalData.id) handlegetAllFreelancersByProfessionalId(professionalData.id)
  }, [professionalData])

  const handlegetAllFreelancersByProfessionalId = async (professionalId) => {
    const allFreelancers = await getAllFreelancersByProfessionalId(professionalId)
    const freelancerList = allFreelancers.map(freelancer => {
      return { value: freelancer.id, label: freelancer.name }
    })
    setSubstituteList(freelancerList)
  }

  const handleAllDay = () => {
    setStartTime('00:00')
    setEndTime('00:00')
    handleStartDate(startDate)
  }

  const onSubmit = async event => {
    event.preventDefault()
    event.stopPropagation()

    setLoading(true)

    const errorsList = {}
    const momentStart = moment(startDate + ' ' + startTime, 'YYYY-MM-DD HH:mm')
    const momentEnd = moment(endDate + ' ' + endTime, 'YYYY-MM-DD HH:mm')
    const momentNow = moment(new Date()).startOf('day')

    if (!momentStart.isValid() || moment(startDate) < momentNow) {
      errorsList.startDate = 'Data de início inválida'
    } else if (momentStart.isAfter(momentEnd)) {
      errorsList.startDate = 'Data de início não pode ser maior que a data de término'
    }

    if (!momentEnd.isValid() || moment(endDate) < momentNow) {
      errorsList.endDate = 'Data de término inválida'
    }

    if (!Object.keys(RECURRENCE).includes(selectedRecurrence)) {
      errorsList.selectedRecurrence = 'Selecione a recorrência'
    }

    if (Object.keys(errorsList).length) {
      setErrors(errorsList)
    } else {
      const solicitation = {
        start: moment(startDate + ' ' + startTime, 'YYYY-MM-DD HH:mm').utc().toDate(),
        end: moment(endDate + ' ' + endTime, 'YYYY-MM-DD HH:mm').utc().toDate(),
        recurrence: selectedRecurrence
      }

      if (selectedSubstitute) {
        solicitation.professionalSubstituteId = selectedSubstitute
      }

      const response = await sendSolicitation({
        professionalId: professionalData.id,
        kind: SOLICITATION_CATEGORY.AGENDA_BLOCK,
        solicitation
      })

      if (response.errors) {
        Swal.fire({
          title: '<h3 style=\'color: #000; font-size: 24px; font-weight: 700; font-family: "Nunito"\'>Erro!</h3>',
          html: `<p style="color: #000;">${response.errors}</p>`,
          icon: 'error',
          showCancelButton: false,
          showConfirmButton: false,
          showCloseButton: true,
          background: '#fff',
          customClass: { closeButton: 'colorBlack' }
        })
      } else {
        handleUpdateSolicitation(
          response.data.id,
          {
            ...response.data,
            solicitation: {
              ...response.data.solicitation,
              ...(selectedSubstitute) && {
                professionalSubstituteId: {
                  _id: response.data.solicitation.professionalSubstituteId,
                  name: substituteList.find(substitute => substitute.value === selectedSubstitute).label
                }
              }
            }
          }
        )
        Swal.fire({
          title: '<h3 style=\'color: #fff; font-size: 24px; font-weight: 400; font-family: "Nunito"\'>Solicitação <br><strong>enviada com<br> sucesso!</strong></h3>',
          text: '',
          icon: 'success',
          iconColor: '#fff',
          showCancelButton: false,
          showConfirmButton: false,
          showCloseButton: true,
          background: '#009CA6',
          customClass: { closeButton: 'colorWhite' }
        }).then((result) => {
          if (result.isDismissed) handleBackPage()
        })
      }
    }

    setLoading(false)
  }

  const handleStartDate = start => {
    setErrors({
      ...errors,
      startDate: undefined
    })
    setStartDate(start)

    const isFullDay = startTime === '00:00' && endTime === '00:00'
    const endDateBlocked = selectedRecurrence === 'NONE' || selectedRecurrence === ''
    const momentStart = moment(start)
    const momentEnd = moment(endDate)
    const nextDay = momentStart.add(1, 'day').format('YYYY-MM-DD')

    if (
      (isFullDay && endDateBlocked) ||
      (isFullDay && !endDateBlocked && momentStart >= momentEnd)
    ) {
      setEndDate(nextDay)
    } else if (!isFullDay && endDateBlocked) {
      setEndDate(start)
    }
  }

  const recurrenceOptions = getRecurrenceOptions(startDate)

  return (
    <SideMenuTemplate>
      <Alert type='lock' show>
        Essa área é privada e outros veterinários da clínica não tem acesso. Acompanhe nesta área apenas suas solicitações.
      </Alert>
      <Title>Novo bloqueio de agenda</Title>
      <form onSubmit={onSubmit}>
        <Row>
          <Input
            label='De'
            type='date'
            value={startDate}
            onChange={(e) => handleStartDate(e.target.value)}
            errorMessage={errors.startDate}
          />
          <DatePicker
            selected={moment(startTime, 'HH:mm').toDate()}
            className='solicitation-time-picker'
            disabledKeyboardNavigation
            locale="ptBR"
            required
            dateFormat="HH:mm"
            placeholderText='00:00'
            minDate={new Date()}
            onChange={value => {
              if (!value) return
              setStartTime(moment(value).format('HH:mm'))
            }}
            showTimeSelect
            showTimeSelectOnly
            timeIntervals={10}
            timeCaption='Horário de início'
          />
        </Row>
        <Row>
          <Input
            label='Até'
            type='date'
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            errorMessage={errors.endDate}
            disabled={selectedRecurrence === 'NONE' || selectedRecurrence === ''}
          />
          <DatePicker
            selected={moment(endTime, 'HH:mm').toDate()}
            className='solicitation-time-picker'
            disabledKeyboardNavigation
            locale="ptBR"
            required
            dateFormat="HH:mm"
            placeholderText='00:00'
            minDate={new Date()}
            onChange={value => {
              if (!value) return
              setEndTime(moment(value).format('HH:mm'))
            }}
            showTimeSelect
            showTimeSelectOnly
            timeIntervals={10}
            timeCaption='Horário de término'
          />
        </Row>
        <Row>
          <Checkbox label='Dia inteiro' checked={allDayChecked} onChange={handleAllDay} />
        </Row>
        <Row>
          <Select
            label='Escolha quando esse bloqueio se repete'
            initialValue={selectedRecurrence}
            options={recurrenceOptions}
            onChange={setSelectedRecurrence}
            errorMessage={errors.selectedRecurrence}
          />
        </Row>
        {professionalData?.category === 'FRANCHISING' && (
          <Row>
            <Select
              label='Indique um profissional substituto'
              options={substituteList}
              selectedValue={selectedSubstitute}
              onChange={setSelectedSubstitute}
              errorMessage={errors.selectedSubstitute}
              emptyLabel='Nenhum'
            />
          </Row>
        )}
        <Row>
          <CustomButton type='submit' disabled={loading}>Salvar e enviar bloqueio</CustomButton>
          <CustomButton onClick={handleBackPage} outline>
            <FaChevronLeft color='#01878E' size='14' />
            Voltar
          </CustomButton>
        </Row>
      </form>
    </SideMenuTemplate>
  )
}

export default AgendaBlockSolicitationView
